/**
 * StyledDialogStat is for displaying a single inline piece of info, label on
 * left, value on right. Multiple stats are placed inside a StyledDialogStats.
 */

export const StyledDialogStat = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex justify-between">
      <span className="font-medium text-contentSecondary">{label}</span>
      <span className="font-normal text-contentPrimary">{children}</span>
    </div>
  );
};

export const StyledDialogStats = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col gap-2 text-xs">{children}</div>;
};
